import { useContext } from 'react';
import api from 'types/auth';
import JWTContext from 'contexts/JWTContext';
const useAuth = () => {
    const context = useContext(JWTContext);
    if (!context) {
        throw new Error('useAuth must be used within JWTProvider');
    }
    return context;
};
export type RegisterPayload = {
    email: string;
    password: string; // '' if invite flow
    first_name: string;
    last_name: string;
    country: string; // ISO code like 'AE'
    phone: string;
    is_approved?: 0 | 1; // default 1 if omitted
    requires_verification?: 0 | 1;
    role_id?: number | null;
    invite?: boolean;
};
export async function register(payload: RegisterPayload) {
    return api.post('/register', payload);
}
export default useAuth;
